import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { SiteForm } from '../../models/site.model';
import Copyright from '../common/Copyright';
import BasicData from './BasicData';
import Description from './Description';
import MainContainer from '../common/MainContainer';
import FormSection, { FormConfirm, FormElement } from '../common/FormSection';
import AlertMessage from '../common/AlertMessage';
import ActionButton from '../common/ActionButton';
import { useNotification } from '../../context/NotificationContext';


interface HandleFormProps {
  action?: string
  handleChange?: (e: any) => void
  handleSelection: (...args: any[]) => void
  setBlockScreen:  (p: boolean) => void
  onSubmit: (p: any) => void
  siteForm: any
}

export default function HandleForm({
  action,
  handleChange,
  handleSelection,
  setBlockScreen,
  onSubmit,
  siteForm }: HandleFormProps) {
    const { handleSubmit } = useForm<SiteForm>()
    const { showNotification } = useNotification();
    
    const requiredFields = ['name']
    
    const formValidator = () => {
      return requiredFields.some((key) => !siteForm[key] || Object.keys(siteForm[key]).length === 0)
    }
    
    const initComponent = () => {
      if (action === "create" || action === 'edit') {
        setBlockScreen(true)
        Promise.all([
        ]).then(function () {
          setBlockScreen(false)
        }).catch((error) => {
          showNotification(error.response.data)
          setBlockScreen(false)
        });
      }
    }
    
    useEffect(initComponent, [action])

    return (
      <React.Fragment>
        <MainContainer>
          <FormSection>
            <FormElement>
                <BasicData
                  action={action}
                  handleChange={handleChange}
                  handleSelection={handleSelection}
                  siteForm={siteForm}
                />
            </FormElement>

            <FormElement>
                <Description
                  action={action}
                  handleChange={handleChange}
                  siteForm={siteForm}
                />
            </FormElement>

          {(action === 'create' || action === 'edit') && (
            <FormConfirm>
              <div className='text-secondary'>
                <p>
                  (*) Campos requeridos
                </p>
              </div>

              {(formValidator()) && (
                <div>
                  <AlertMessage
                    severity="error"
                    message='Hay campos requeridos sin completar' />
                </div>
              )}

              <div>
                <ActionButton
                  text="Confirmar"
                  type="confirm"
                  onClick={handleSubmit(onSubmit)}
                  disabled={formValidator()}
                />
              </div>

            </FormConfirm>
          )}
          </FormSection>
        </MainContainer>
        <Copyright />
      </React.Fragment >
    );
}
